import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import ProjectTab from './ProjectTab';

const ProjectListContainer = () => {
  return (
    <>
      <Container fluid={true}>
        <Breadcrumbs justify='end' pageTitle='Project List' parent='Project' title='Project List' />
        <Row className='project-cards'>
          <ProjectTab />
        </Row>
      </Container>
    </>
  );
};

export default ProjectListContainer;
